/**
 * PAGE TOPボタンの機能実装
 */

export function initPageTop() {
    const pageTopButton = document.getElementById('pageTop');
    
    if (!pageTopButton) {
        return;
    }

    // スクロール位置に応じてボタンの表示/非表示を制御
    function togglePageTopButton() {
        // Lenisが利用可能な場合はLenisから取得、そうでなければ通常の方法
        const scrollTop = (window.lenis && window.lenis.isInitialized) 
            ? window.lenis.scroll 
            : (window.pageYOffset || document.documentElement.scrollTop);
        
        if (scrollTop > 300) {
            pageTopButton.style.opacity = '1';
            pageTopButton.style.visibility = 'visible';
        } else {
            pageTopButton.style.opacity = '0';
            pageTopButton.style.visibility = 'hidden';
        }
    }

    // ページトップにスムーズスクロール
    function scrollToTop() {
        // Lenisが利用可能な場合はLenisを使用、そうでなければ通常のスクロール
        if (window.lenis && window.lenis.isInitialized) {
            window.lenis.scrollTo(0, {
                duration: 1.5,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
            });
        } else {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    // イベントリスナーを追加
    // Lenisが利用可能な場合はLenisのscrollイベントを使用
    // 初期化のタイミングを考慮して、少し遅延させてから設定
    setTimeout(() => {
        if (window.lenis && window.lenis.isInitialized) {
            window.lenis.on('scroll', togglePageTopButton);
        } else {
            window.addEventListener('scroll', togglePageTopButton);
        }
    }, 100);
    
    pageTopButton.addEventListener('click', scrollToTop);

    // 初期状態を設定
    pageTopButton.style.transition = 'opacity 0.3s ease, visibility 0.3s ease';
    pageTopButton.style.opacity = '0';
    pageTopButton.style.visibility = 'hidden';

}
